import styled from "styled-components";
import dotBackgroundImage from "../../assets/images/dot-bg.svg";
import { Link } from "react-router-dom";

export const Letter = styled("span")`
  font-size: 12px;
`;

export const Number = styled("span")`
  width: 18px;
  height: 18px;
  background: red;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  color: white;
  font-size: 14px;
`;

export const Accordion = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 7px;
`;

export const AccordionItem = styled("div")<{ showNumbers }>`
  display: flex;
  gap: 18px;
  width: 100%;
  position: relative;
  padding-bottom: 4px;
  overflow: hidden;

  ${({ showNumbers }) => {
    return showNumbers
      ? `&:not(:last-child) {
      &:before {
        content: "";
        display: block;
        width: 2px;
        height: 100%;
        position: absolute;
        left: 8px;
        top: 22px;
        background-image: url(${dotBackgroundImage});
      }
    }`
      : "";
  }}
`;

export const Unit = styled("div")`
  display: flex;
  width: 100%;
  gap: 7px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  background-color: white;
  padding: 7px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
`;

export const UnitModules = styled("div")`
  padding: 0px 0px 0px 30px;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 7px;
`;

const moduleStyles = ({ completed, current }: { completed: boolean; current: boolean }) => `
  display: flex;
  min-height: 22px;
  padding: 4px 10px;
  border-radius: 2px;
  gap: 7px;
  background-color: ${completed ? 'rgba(239, 239, 239, .5)' : 'rgba(239, 239, 239, 1)'};
  color: ${completed && !current ? 'rgba(0,0,0, .5)' : 'inherit'};
  text-decoration: none;
`;

export const Module = styled.div<{ completed: boolean; current: boolean; to?: string }>`
  ${moduleStyles};
  cursor: default;
`;

export const ModuleLink = styled(Link)<{ completed: boolean; current: boolean }>`
  ${moduleStyles};
`;

export const Toggle = styled("div")`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
  }
`;
